import React, { Component } from 'react';
/* eslint-disable */
import axios from 'axios';
import { MY_API_URL } from '../QueryMe';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import Alert from '../../../shared/components/Alert';
import ProfileImage from '../ProfileImage';
import { Link, withRouter } from 'react-router-dom';
import Select from 'react-select';
const apiurl = MY_API_URL;

const initialstate = {
	email: localStorage.by,
	name: localStorage.name,
	mobile: localStorage.pmobile,
	image: localStorage.profile_img,
	technologies: localStorage.technologies,
	showAlert: false,
	alertType: '',
	alertText: '',
	profile: null,
	prefix: localStorage.sufix,
	prefixoptions: [],
};
class ProfileEdit extends Component {
	constructor(props) {
		super(props);
	}
	state = { ...initialstate };

	componentDidMount() {
		if (localStorage.gotodash === '1') {
			this.props.history.push({
				pathname: '/dashboard',
				backTo: '/',
			});
		} else {
			let fsprefix = localStorage.sufix;
			let flprefix = [];
			let fnprefix = '';
			if (fsprefix) {
				flprefix = fsprefix.split('@');
				fnprefix = flprefix[1];
			}

			this.setState({ nprefix: fnprefix });
			this.handleGetprefix(localStorage.token);
		}
	}

	handleSelectChange = (selectedOption) => {
		let sprefix = selectedOption.value;
		let lprefix = sprefix.split('@');

		let nprefix = lprefix[1];
		this.setState({ prefix: sprefix, nprefix: nprefix });
	};

	handleChange = (event) => {
		const { name, value } = event.target;
		console.log(name + ' ' + value);
		this.setState({ [name]: value });
	};
	handleProfileSubmit = (event) => {
		event.preventDefault();
		if (isNaN(this.state.mobile)) {
			this.setState({
				showAlert: true,
				alertType: 'warning',
				alertText: 'Invalid Mobile',
			});
		} else {
			const headers = {
				'Content-Type': 'application/json',
				Authorization: localStorage.token,
			};
			var postData = {
				email: this.state.email,
				mobile: this.state.mobile,
				name: this.state.name,
				image: this.state.image,
				role: localStorage.roleSelected,
				technologies: localStorage.technologies,
				prefix: this.state.prefix,
			};
			const pupurl = apiurl + 'updateUserProfile';
			axios
				.post(pupurl, postData, {
					headers: headers,
				})
				.then((response) => {
					console.log('Response is ', response.data);
					console.log(response.data.message);
					if (response.data.error) {
						this.setState({
							showAlert: true,
							alertType: 'warning',
							alertText: response.data.message,
						});
					} else {
						this.setState(
							{
								showAlert: true,
								alertType: 'success',
								alertText: response.data.message,
								showEbox: false,
								showObox: true,
							},
							() => {
								localStorage.setItem('profile_img', this.state.image);
								localStorage.setItem('name', this.state.name);
								localStorage.setItem(
									'mobile',
									this.state.nprefix + '-' + this.state.mobile,
								);

								localStorage.setItem('pmobile', this.state.mobile);
								localStorage.setItem('sufix', this.state.prefix);
								localStorage.setItem('profile_completed', 1);
								localStorage.setItem('gotodash', 1);
								window.location.reload(false);
							},
						);
					}
				})
				.catch((error) => {
					console.log('Error is ', error);
					this.setState({
						alertType: 'danger',
						showAlert: true,
						alertText: 'Request Failed Try again Later!',
					});
				});
		}
	};
	uploadImage = (mfile) => {
		const proimg = mfile.target.files[0];
		console.log(this.state.image);
		// console.log(mfile.target.files[0]);
		// console.log(proimg);
		const data = new FormData();

		data.append('proimg', proimg);
		data.append('email', this.state.email);
		data.append('role', localStorage.roleSelected);
		const proimgurl = apiurl + 'imgupload';
		axios
			.post(proimgurl, data)
			.then((response) => {
				// console.log('Response is ', response.data);
				// console.log(response.data.message);
				if (response.data.error) {
					this.setState({
						showAlert: true,
						alertType: 'warning',
						alertText: response.data.message,
					});
				} else {
					const headers = {
						ContentType: proimg.type,
					};
					const imgtopost = response.data.imgtopost;
					const newfile = response.data.fileurl;
					console.log(newfile);
					// console.log(imgtopost);
					// console.log(proimg);
					axios
						.put(imgtopost, proimg, headers)
						.then((response) => {
							this.setState(
								{
									showAlert: false,
									image: newfile,
								},
								() => {
									console.log(this.state.image);
								},
							);
						})
						.catch((error) => {
							console.log('Error is ', error.response);
							this.setState({
								alertType: 'danger',
								showAlert: true,
								alertText: 'Failled Try Again Later!',
							});
						});
				}
			})
			.catch((error) => {
				this.setState({
					alertType: 'danger',
					showAlert: true,
					alertText: 'Failled Try Again Later!',
				});
			});
	};
	handleGetprefix = (token) => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			status: 1,
		};
		const getuurl = apiurl + 'getprefix';
		axios
			.post(getuurl, postData, {
				headers: headers,
			})
			.then((response) => {
				console.log('allprefix: ', response.data.allprefix);
				if (response.data.error) {
				} else {
					let allprefix = response.data.allprefix;
					let prefixoptions = [];

					allprefix.map((prefix, index) => {
						var flagname = prefix.ccode;
						flagname = flagname.toLowerCase();
						let prefixname =
							prefix.cname + '@' + prefix.prefix + '@' + prefix.id;

						prefixoptions.push({
							value: prefixname,
							label: (
								<div className="counoption">
									<img
										src={'flags/' + flagname + '.svg'}
										width="25px"
										height="15px"
									/>
									{prefix.prefix + ' - ' + prefix.cname}
								</div>
							),
						});
					});
					this.setState({
						prefixoptions: prefixoptions,
					});
				}
			})
			.catch((error) => {
				// localStorage.clear();
				// this.props.history.push('/');
			});
	};
	render() {
		const {
			email,
			name,
			mobile,
			image,
			showAlert,
			alertType,
			alertText,
			prefixoptions,
			prefix,
		} = this.state;

		const profileimginfo = { clname: '', flpath: { image } };
		return (
			<div className="account">
				<div className="account__wrapper">
					<div className="account__card">
						<div className="account__head">
							<h3 className="account__title">Edit Profile</h3>
							<h4 className="account__subhead subhead">
								<Link to="/profile">Back to Profile</Link>
							</h4>
						</div>

						{this.state.showAlert ? (
							<Alert color={this.state.alertType}>
								<p>{this.state.alertText}</p>
							</Alert>
						) : null}

						<form
							className="form"
							onSubmit={(event) => this.handleProfileSubmit(event)}
						>
							<div className="profile__information">
								<div className="profile__avatar">
									<ProfileImage clname="" flpath={this.state.image} />
								</div>
							</div>
							<div className="form__form-group">
								<span className="form__form-group-label">Profile Image</span>
								<div className="form__form-group-field">
									<input type="file" onChange={this.uploadImage} />
								</div>
							</div>
							<div className="form__form-group">
								<span className="form__form-group-label">Email ID</span>
								<div className="form__form-group-field">
									<div className="form__form-group-icon">
										<AccountOutlineIcon />
									</div>

									<input
										name="email"
										type="email"
										placeholder="Your Email"
										defaultValue={this.state.email ? this.state.email : ''}
										required
										readOnly
									/>
								</div>
							</div>
							<div className="form__form-group">
								<span className="form__form-group-label">Your Full Name</span>
								<div className="form__form-group-field">
									<div className="form__form-group-icon">
										<AccountOutlineIcon />
									</div>

									<input
										name="name"
										type="text"
										placeholder="Your Full Name"
										defaultValue={this.state.name ? this.state.name : ''}
										onChange={this.handleChange}
										required
									/>
								</div>
							</div>
							<div className="form__form-group">
								<span className="form__form-group-label">Your Mobile</span>
								<div className="form__form-group-field">
									<Select
										name="prefix"
										value={prefixoptions.filter(
											(option) => option.value == prefix,
										)}
										onChange={this.handleSelectChange}
										options={prefixoptions}
										clearable={false}
										placeholder="Country"
										className="react-select"
										classNamePrefix="react-select"
										// defaultMenuIsOpen={true}
										// isDisabled={true}
									/>

									<input
										name="mobile"
										type="text"
										placeholder="Your Mobile"
										defaultValue={this.state.mobile ? this.state.mobile : ''}
										onChange={this.handleChange}
										pattern="^\d{10}$"
										title="Min and Max 10 Digits"
										required
									/>
								</div>
							</div>

							<button
								className="btn btn-primary account__btn account__btn--small"
								// onClick={this.handleProfileSubmit}
								type="submit"
							>
								Update Profile
							</button>
						</form>
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(ProfileEdit);
